import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import Navbar from '@/components/Navbar';
import { CheckCircle, XCircle, CircleNotch } from '@phosphor-icons/react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const [state, setState] = useState('checking'); // checking | ok | fail
  const [detail, setDetail] = useState('');

  useEffect(() => {
    const token = params.get('token');
    if (!token) { setState('fail'); setDetail('This link is missing its verification code.'); return; }
    axios.post(`${API}/auth/verify-email`, { token })
      .then((r) => { setState('ok'); setDetail(r.data.email || ''); })
      .catch((err) => { setState('fail'); setDetail(err?.response?.data?.detail || 'Verification failed. Please try again.'); });
  }, [params]);

  return (
    <div className="min-h-screen bg-background" data-testid="verify-email-page">
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-24 text-center fade-up">
        {state === 'checking' && (
          <>
            <CircleNotch size={40} className="text-primary mx-auto mb-4 animate-spin" />
            <p className="text-muted-foreground text-sm">Verifying your email…</p>
          </>
        )}
        {state === 'ok' && (
          <>
            <div className="w-14 h-14 bg-emerald-500/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <CheckCircle size={30} weight="fill" className="text-emerald-600" />
            </div>
            <h1 className="font-heading text-2xl text-foreground mb-2">Email verified!</h1>
            <p className="text-muted-foreground text-sm mb-8">{detail ? `${detail} is confirmed. ` : ''}Your provider account is one step closer to going live.</p>
            <Link to="/provider/dashboard" className="inline-block bg-primary text-primary-foreground rounded-xl px-6 py-3 text-sm font-semibold btn-anim shadow-soft hover:bg-primary/90 no-underline" data-testid="verify-continue">
              Go to my dashboard
            </Link>
          </>
        )}
        {state === 'fail' && (
          <>
            <div className="w-14 h-14 bg-red-500/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <XCircle size={30} weight="fill" className="text-red-500" />
            </div>
            <h1 className="font-heading text-2xl text-foreground mb-2">Couldn't verify</h1>
            <p className="text-muted-foreground text-sm mb-8" data-testid="verify-error">{detail}</p>
            <Link to="/provider/dashboard" className="inline-block bg-secondary text-primary rounded-xl px-6 py-3 text-sm font-semibold btn-anim no-underline">
              Go to my dashboard to resend the link
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
